// extracted by mini-css-extract-plugin
export default {"invitedCarrierContainer":"style_invitedCarrierContainer__o06Gz","descriptionWrapper":"style_descriptionWrapper__x+JyC"};